<div class="page-layout-small padding-large m-margin-none m-padding m-padding-top-largest">
	<div class="flex margin-bottom">
		<div class="flex-1 flex center">
			<h4>Search Shots templates</h4>
		</div>
	</div>

	<div class="flex wrap gap">
		<div class="filter-chip" [ngClass]="!templateFilters.brands || !templateFilters.brands.length ? '' : 'selected'">
			@if (templateFilters.brands && templateFilters.brands.length) {
				<div class="flex center hover" (click)="openBrandFilterModal()">
					<b class="margin-right-smallest">Brand:</b>

					@for (brand of templateFilters.brands; track brand; let last = $last) {
						{{ brand.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('brands')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openBrandFilterModal()">
					Brand
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip" [ngClass]="!templateFilters.categories || !templateFilters.categories.length ? '' : 'selected'">
			@if (templateFilters.categories && templateFilters.categories.length) {
				<div class="flex center hover" (click)="openCategoryFilterModal()">
					<b class="margin-right-smallest">Category:</b>
					@for (category of templateFilters.categories; track category; let last = $last) {
						{{ category.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('categories')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openCategoryFilterModal()">
					Category
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip disabled" [ngClass]="!templateFilters.styleGroups || !templateFilters.styleGroups.length ? '' : 'selected'">
			@if (templateFilters.styleGroups && templateFilters.styleGroups.length) {
				<div class="flex center hover" (click)="openStyleGroupFilterModal()">
					<b class="margin-right-smallest">Style Group:</b>
					@for (styleGroup of templateFilters.styleGroups; track styleGroup; let last = $last) {
						{{ styleGroup.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('styleGroups')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openStyleGroupFilterModal()">
					Style Group
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>

		<div class="filter-chip disabled" [ngClass]="!templateFilters.teams || !templateFilters.teams.length ? '' : 'selected'">
			@if (templateFilters.teams && templateFilters.teams.length) {
				<div class="flex center hover" (click)="openTeamFilterModal()">
					<b class="margin-right-smallest">Team:</b>
					@for (team of templateFilters.teams; track team; let last = $last) {
						{{ team.name }}
						@if (!last) {
							,
						}
					}
				</div>
				<mat-icon class="hover" (click)="cleanFilter('teams')">close</mat-icon>
			} @else {
				<div class="flex center hover" (click)="openTeamFilterModal()">
					Team
					<mat-icon class="hover">edit</mat-icon>
				</div>
			}
		</div>
	</div>

	@if (templates && templates.items && templates.items.length) {
		<div class="flex column end between margin-bottom margin-top-small">
			<button [routerLink]="['/company/template-detail/new']" class="flex center">
				<i class="fa fa-solid fa-plus margin-right-smallest"></i>
				Create Template
			</button>
		</div>

		<bt-paginator [pageNumber]="templates.currentPage" [pageSize]="templates.size" [totalNumber]="templates.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>

		<table class="margin-top-smallest">
			<tr>
				<th>Name</th>

				<th>Shots</th>
				<th>Action</th>
			</tr>
			@for (item of templates.items; track item) {
				<tr>
					<td>
						<div class="flex column">
							@if (item.isDefault) {
								<div class="flex center">
									<span class="margin-right-smallest bold">Default template</span>
								</div>
								<span class="grey small margin-top-smallest">
									<i class="fa fa-solid fa-lock margin-right-smallest"></i>
									This template is used as default for styles without a specific template.
								</span>
							} @else {
								<div class="flex center">
									<span class="margin-right-smallest bold">Template {{ item.id }}</span>
								</div>

								<div class="flex wrap gap margin-top-small">
									@if (item.brand?.name) {
										<span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">Brand: {{ item.brand.name }}</span>
									}
									@if (item.collection?.name) {
										<span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">Collection: {{ item.collection.name }}</span>
									}
									@if (item.category?.name) {
										<span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">Category: {{ item.category.name }}</span>
									}
									@if (item.gender?.name) {
										<span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">Gender: {{ item.gender.name }}</span>
									}
									@if (item.styleGroup?.name) {
										<span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">Style Group: {{ item.styleGroup.name }}</span>
									}
									@if (item.styles && item.styles.length) {
										<span class="radius bg-lightest-blue e padding-right-smallest padding-left-smallest">
											Styles:
											@for (style of item.styles; track $index; let last = $last) {
												{{ style.code }}
												@if (!$last) {
													,
												}
											}
										</span>
									}
									@if (item.colors && item.colors.length) {
										<span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">
											Colors:
											@for (color of item.colors; track $index; let last = $last) {
												{{ color.code }} {{ color.name }}
												@if (!$last) {
													,
												}
											}
										</span>
									}
								</div>
							}
						</div>
					</td>

					<td class="nowrap">{{ item.shots?.length || 0 }} shots</td>
					<td>
						<div class="flex center">
							<a [routerLink]="['/company/template-detail/' + item.id]" class="hover primary flex center margin-right-small">
								<mat-icon class="small margin-right-smallest">visibility</mat-icon>
								View
							</a>
							@if (!item.isDefault) {
								<span class="hover red flex center" (click)="removeTemplate(item)">
									<i class="fa fa-xmark small margin-right-smallest"></i>
									Remove
								</span>
							}
						</div>
					</td>
				</tr>
			}
		</table>

		<bt-paginator [pageNumber]="templates.currentPage" [pageSize]="templates.size" [totalNumber]="templates.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>
	}

	@if (templates.items.length == 0 && !loading) {
		<div class="flex center bg-light-grey padding-largest justify-center">
			<div class="flex column center gap">
				<i class="fa fa-search fa-2xl margin-bottom grey"></i>
				<span>No data found</span>
			</div>
		</div>
	}
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
